export default function ({ props, state }) {
    const { answers, data } = state.get('app');
    const { tips } = data;
    const {
        part, isLast,
    } = props;
    if (isLast && part === 'test-je-kennis') {
        let personalTips = Object.values(answers[part])
            .filter(a => !a.correct)
            .sort((a, b) => a.weight < b.weight)
            .slice(0, 2)
            .map(a => a.tip);

        if (personalTips.length === 0) {
            personalTips = Object.values(tips)
                .sort((a, b) => a.weight < b.weight)
                .slice(0, 2)
                .map(t => t.tip);
        } else if (personalTips.length === 1) {
            personalTips.push(Object.values(tips)
                .sort((a, b) => a.weight < b.weight)[0]
                .tip);
        }
        state.set('app.answers.tips', personalTips);
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/app/actions/setTips.js